import Layout from "./Layout";
import PaymentOptions from "../components/PaymentOptions";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import TimeOutModal from "../components/TimeOutModal";
import CardInfoModal from "../components/CardInfoModal";
import DataContext from "../contexts/DataProvider";
import FormDataContext from "../contexts/FormData";
import axios from "axios";
import Countdown from "react-countdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faIndianRupeeSign } from "@fortawesome/free-solid-svg-icons";
import GetAPI from "../helper/GetAPI";
import SuccessOrFailed from "./SuccessOrFailed";
import Page404 from "./Page404";
import swinkpay_logo from "../assets/swinklogo.png";
import dots from "../assets/dots_animated.svg";
import phonepe from "../assets/phonepe.png";
import gpay from "../assets/gpay.png";
import paytm from "../assets/paytm.png";
import bhim from "../assets/bhim.png";
import visa from "../assets/visa.png";
import mastercard from "../assets/mastercard.png";
import rupay from "../assets/rupay.png";
import useDetectKeyboardOpen from "../helper/useKeyboardOpen";
import Spinner from "../components/Spinner";
import dateFormat from "dateformat";
import toast, { Toaster } from "react-hot-toast";
import { ReactSVG } from "react-svg";
import classNames from "classnames";
import pci from "../assets/pci.png";
import { AiFillClockCircle, AiOutlineClose } from "react-icons/ai";
import { FaLock } from "react-icons/fa";
import { MdOutlineShoppingBag } from "react-icons/md";
import { isAndroid, isIOS } from "react-device-detect";
import FormatAmount from "../helper/FormatAmount";
import BillPayment from "../assets/BillPayment.png";
import { getFirstLegData, getSearchData } from "../constant/app.const";
import ProgessScreen from "../components/ProgresScreen";
import CancelButtonModal from "../components/CancelButtonModal";
import SwinkSpinner from "../components/SwinkSpinner";
import ContactDetails from "../components/ContactDetails";
import analytics from "../helper/analytics";
import PaymentHeader from "../components/PaymentHeader";

const allMethods = ["UPI", "CARD", "NETBANKING", "WALLET"];

let deciload = 1;


const Amount = ({ setShowModal, showModal, timeLeft, isKeyboardOpen, viewportWidth }) => {
  const isMobileWithKeyboard = isKeyboardOpen && viewportWidth < 640;

  const renderer = ({ hours, minutes, seconds, completed }) => {
    let newSeconds = Number(seconds) < 10 ? "0" + seconds : seconds;
    const totalMins = hours * 60 + minutes + seconds / 60;
    if (completed) {
      setShowModal(true);
      return null;
    }
    const color = totalMins >= 1 ? "#1E56C8" : "#DC2626";
    const borderColor = totalMins >= 2 ? "rgba(30,86,200,0.30)" : totalMins >= 1 ? "rgba(245,158,11,0.7)" : "rgba(220,38,38,0.7)";
    return (
      <div className="flex items-center gap-1 px-2 py-0.5 rounded-full transition-all duration-700"
           style={{ background: "rgba(30,86,200,0.06)", border: `1px solid ${borderColor}` }}>
        <AiFillClockCircle style={{ color, fontSize: 10 }} />
        <span className="text-xs font-bold tabular-nums" style={{ color }}>{`0${minutes}:${newSeconds}`}</span>
        <span className="text-[10px] font-medium text-gray-400">mins</span>
      </div>
    );
  };

  return (
    <PaymentHeader
      amountLabel="PAYABLE AMOUNT"
      labelColor="#1E56C8"
      hideTopRow={isMobileWithKeyboard}
      compactAmount={isMobileWithKeyboard}
      right={!showModal ? <Countdown date={timeLeft} renderer={renderer} /> : null}
    />
  );
};

const PaymentMode = () => {
  // https://sandbox.swinkpay-fintech.com/plugin/?uniqeTransactionid=Test21234591353r28249&amount=155.00&
  // currency=INR&discount=0&tax=0&mid=0000000000050285&tid=SVHMUAJU&token=4d270489-dfc9-4ca8-a662-8eace9c15f78&
  // txnid=testtxnid&divid=kGyQVt%2F8TC0h1ys5O0rNJmKO4xhDXk4VbyK6K2srmAe3ZdZJrDUrh7Rk%2BF5pgRffK6VPguMsQRYZMot%2FBL
  // EX6mcCupmKW9ykonzLEfY%2Bu3iT9yMx4l4jM1GWqaak%2FTrBLSJ2EjnmdNCBIr41069BUzJ088a%2Bezwm8HPhG9MC1KXKaLgl0UmCfotYzgi
  // qXOGNUWQevvKCvPFcVemAZTHO0wud%2BiM9YURPcBQZ9NOTW8keXRXpMyEfkTfiqPQudaDWF%2FLu8XI8BdWrWnOOe1Z9WJT9V4dlc1ziOMgakO
  // PMrK%2FBUEPNoRjyvvtjaI3rZlaapt4tOxb5%2B5oAPIlh3Q6O6g%3D%3D&
  // logo=https%3A%2F%2Fsandbox.swinkpay-fintech.com%2Fapi%2Fv2%2Fimage%2Fmnt%2FAppBuilds%2Fimages%2Fmerchant%2F7%2F
  // 2%2F1%2F3%2Fimages.jpg&colour=%233707e4&datakey=7Q2LqiBlXnPOkwnKDB3hMosIhifI9ZYB&pg=8&returnURL=https%3A%2F%2Fs
  // andbox.swinkpay-fintech.com%2Fplugin%3F#/login

  // Endpoint for cashfree(pg=8): https://sandbox.swinkpay-fintech.com/api/v2/plugin/cf/firstleg
  // Endpoint for billdesk(pg=2): https://sandbox.swinkpay-fintech.com/api/v2/plugin/bd/firstleg

  const [searchParams] = useSearchParams();
  // Snapshot URL params at mount so async functions always see the original values
  // even after pushState strips them from the browser URL later.
  const refnum = useRef(searchParams.get("refnum") || "");
  const transactionId = useRef(searchParams.get("transactionId") || "");
  const [showModal, setShowModal] = React.useState(false);
  const { data, setData } = useContext(DataContext);
  const { formData, setFormData, showProcessingScreen, setShowProcessingScreen } = useContext(FormDataContext);
  const isKeyboardOpen = useDetectKeyboardOpen();
  const currentTime = Date.now();
  // Persist the countdown DEADLINE so a page refresh RESUMES the same timer instead of resetting
  // to a fresh 5 minutes. Keyed per-transaction (so a different payment link starts fresh), in
  // sessionStorage (survives refresh, clears when the tab is closed).
  const timerKey = "swinkpay_deadline_" + (searchParams.get("refnum") || searchParams.get("transactionId") || "session");
  const getInitialDeadline = () => {
    try {
      const stored = parseInt(sessionStorage.getItem(timerKey), 10);
      if (Number.isFinite(stored)) return stored; // resume the existing deadline on refresh
    } catch (e) { /* storage unavailable */ }
    const fresh = currentTime + 300000;
    try { sessionStorage.setItem(timerKey, String(fresh)); } catch (e) { /* ignore */ }
    return fresh;
  };
  const [timeLeft, setTimeLeft] = useState(getInitialDeadline);
  const [inProcess, setInProcess] = useState(false);
  const [finishStatus, setFinishStatus] = useState(false);
  const [viewportHeight, setViewportHeight] = useState(
    (window.visualViewport?.height ?? window.innerHeight) + (window.visualViewport?.offsetTop ?? 0)
  );
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);
  const [showBackButton, setShowBackButton] = useState(true);
  const [showCardModal, setShowCardModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const processingRef = useRef(false); // double-click guard
  const backURLRef = useRef(null);     // always holds latest data.backURL for back-button handler
  const merReturnURLRef = useRef(null); // latest data.merReturnURL for the terminal-screen back handler
  const handleCheckStatusRef = useRef(null); // stable ref so polling interval never stale-closes
  const handleAuthStatusRef = useRef(null);
  // const [decisionCall, setDecisionCall] =useState(true);
  const [showTooltip, setShowTooltip] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [dataReady, setDataReady] = useState(false);
  // Razorpay-style contact step: collect mobile + email before showing payment methods
  const [contactSubmitted, setContactSubmitted] = useState(false);
  const [pendingSecondsLeft, setPendingSecondsLeft] = useState(120);
  const [isPendingTimerOver, setIsPendingTimerOver] = useState(false);
  const loadStartRef = useRef(Date.now());
  const MIN_LOADING_MS = 800;
  const loaderHiddenRef = useRef(false);

  // Keep ref in sync so the popstate handler always sees the latest backURL
  useEffect(() => { backURLRef.current = data.backURL || null; }, [data.backURL]);
  useEffect(() => { merReturnURLRef.current = data.merReturnURL || null; }, [data.merReturnURL]);

  const hideLoader = () => {
    if (loaderHiddenRef.current) return;
    loaderHiddenRef.current = true;
    const elapsed = Date.now() - loadStartRef.current;
    const remaining = Math.max(0, MIN_LOADING_MS - elapsed);
    setTimeout(() => {
      setIsLoading(false);
      setDataReady(true);
    }, remaining);
  };

  const tooltipTimeout = 3000; // Timeout in milliseconds

  // remarks modal — no auto-close, user dismisses manually

  useEffect(() => {
    const recalc = () => {
      const vv = window.visualViewport;
      setViewportHeight((vv?.height ?? window.innerHeight) + (vv?.offsetTop ?? 0));
      setViewportWidth(window.innerWidth);
    };
    // Fires in adjustResize mode (WebView resizes)
    window.addEventListener("resize", recalc);
    // Fires when visual viewport resizes (iOS, some Android)
    window.visualViewport?.addEventListener("resize", recalc);
    // Fires in adjustPan mode (Android pans the viewport — scroll moves visual viewport)
    window.visualViewport?.addEventListener("scroll", recalc);
    // Fallback: recalculate after keyboard animation (~300ms) when any input is focused
    const onFocusIn = () => setTimeout(recalc, 300);
    const onFocusOut = () => setTimeout(recalc, 100);
    document.addEventListener("focusin", onFocusIn);
    document.addEventListener("focusout", onFocusOut);
    return () => {
      window.removeEventListener("resize", recalc);
      window.visualViewport?.removeEventListener("resize", recalc);
      window.visualViewport?.removeEventListener("scroll", recalc);
      document.removeEventListener("focusin", onFocusIn);
      document.removeEventListener("focusout", onFocusOut);
    };
  }, []);

  const isNavigatingRef = useRef(false);
  const terminalStateRef = useRef(false);
  const resultTrackedRef = useRef(false); // ensures transaction_result fires once

  useEffect(() => {
    if (data && data.amount !== undefined) {
      const fullAmount = Number((Number(data.amount) + Number(data.discount || 0)).toFixed(2));
      const discountedAmount = Number(data.amount);
      let newTotalAmount = fullAmount;

      if (formData?.modeOfPayment === "CARD") {
        const cardNo = formData?.cardNumber || "";
        // If no card number yet or less than 6 digits, show discounted amount as per requirement
        if (cardNo.length < 6) {
          newTotalAmount = discountedAmount;
        } else {
          const isMatchingBin = checkNumberInBin(cardNo);
          newTotalAmount = isMatchingBin ? discountedAmount : fullAmount;
        }
      } else {
        // UPI, Net Banking, Wallet etc.
        newTotalAmount = fullAmount;
      }

      if (data.totalAmount !== newTotalAmount) {
        setData((prev) => ({ ...prev, totalAmount: newTotalAmount }));
      }
    }
  }, [
    formData?.modeOfPayment,
    formData?.cardNumber,
    data?.bins,
    data?.amount,
    data?.discount,
    data?.totalAmount,
  ]);

  useEffect(() => {
    if ([1, 2].includes(data?.statusCode) || (data?.statusCode === 0 && isPendingTimerOver)) {
      terminalStateRef.current = true;
    }
  }, [data?.statusCode, isPendingTimerOver]);

  const ignoreNextHashChange = useRef(false);

  useEffect(() => {
    isNavigatingRef.current = false;
    window._swinkpay_is_navigating = false;

    const handleBackNavigation = (e) => {
      if (ignoreNextHashChange.current) {
        ignoreNextHashChange.current = false;
        return;
      }
      
      if (isNavigatingRef.current) return;

      // TERMINAL (success / failed / pending) screen — handle FIRST, on ANY Back.
      // The interstitial's reveal() pushes another "#/transaction-active" buffer on top of the
      // one index.js already armed, so a Back pops between two IDENTICAL hashes: location.hash
      // never changes. The "hash removed" check below would therefore never fire on the status
      // screen, and the guard would silently do nothing (the exact bug: Back stayed on the page
      // but no modal appeared). So detect terminal here, independent of the hash value.
      if (terminalStateRef.current) {
        // Re-arm a FRESH buffer so the next Back is trapped too, then show the guard modal.
        // Must use pushState, NOT `location.hash = ...`: after the pop the hash is already
        // "#/transaction-active", so a hash assignment would be a no-op and leave no buffer.
        // pushState always adds a real entry and fires no event, so no ignore flag is needed.
        window.history.pushState(
          null,
          "",
          window.location.pathname + window.location.search + "#/transaction-active"
        );
        setShowCancelModal(true);
        return;
      }

      // ACTIVE payment flow: only react when the protected hash was actually removed.
      if (!window.location.hash || window.location.hash === "#/") {
        // Block the exit + show the Transaction Guard modal.
        ignoreNextHashChange.current = true;
        window.location.hash = "/transaction-active";
        analytics.track("back_button_attempt");
        setShowCancelModal(true);
      }
    };

    // Listen to both for maximum coverage across all browsers
    window.addEventListener("hashchange", handleBackNavigation);
    window.addEventListener("popstate", handleBackNavigation);

    // Initial Trap Setup:
    // We use direct assignment to window.location.hash because it is more likely 
    // to be recorded in history without a user gesture than history.pushState.
    if (!window.location.hash || window.location.hash !== "#/transaction-active") {
      ignoreNextHashChange.current = true;
      window.location.hash = "/transaction-active";
    }

    const preventRefresh = (e) => {
      if (isNavigatingRef.current || window._swinkpay_is_navigating) return;
      e.preventDefault();
      e.returnValue = "";
    };

    const handleKeydown = (e) => {
      if (isNavigatingRef.current) return;
      if ((e.ctrlKey || e.metaKey) && (e.key === "r" || e.key === "R")) e.preventDefault();
      if (e.key === "F5") e.preventDefault();
    };

    window.addEventListener("beforeunload", preventRefresh);
    window.addEventListener("keydown", handleKeydown);

    return () => {
      window.removeEventListener("hashchange", handleBackNavigation);
      window.removeEventListener("popstate", handleBackNavigation);
      window.removeEventListener("beforeunload", preventRefresh);
      window.removeEventListener("keydown", handleKeydown);
    };
  }, []);

  // The SwinkPay reference (SP… id) is assigned by the backend late in the flow.
  // Re-attach it to the analytics context the moment it appears so the later flushes
  // carry it and the backend upsert fills fldswinkpayid on the same session row.
  useEffect(() => {
    if (data?.swinkpayID) analytics.init({ swinkpayId: data.swinkpayID });
  }, [data?.swinkpayID]);

  // Track which top-level screen the user is on, for dwell-time stats.
  // Leaf sections (contact / payment methods) are owned by their child components.
  useEffect(() => {
    if (isLoading || !dataReady) {
      analytics.enterSection("loading");
    } else if (data.show404) {
      analytics.enterSection("not_found");
    } else if ([1, 2].includes(data?.statusCode) || (data?.statusCode === 0 && isPendingTimerOver)) {
      analytics.enterSection("result");
      // transaction_completed is fired by the SuccessOrFailed screen itself (robust across
      // reloads for card / netbanking / wallet). See SuccessOrFailed.js.
    } else if (data?.statusCode === 0) {
      analytics.enterSection("payment_pending");
    } else if (showProcessingScreen) {
      analytics.enterSection("processing");
    }
    // contact / payment-method screens: section is set by ContactDetails / PaymentOptions / UPI
  }, [isLoading, dataReady, data.show404, data?.statusCode, isPendingTimerOver, showProcessingScreen]);

  const SessionTimeOut = (allData) => {
    setTimeout(() => {
      // Handles session timeout
      if (refnum.current) {
        axios
          .get(GetAPI("timeout", allData.pg, refnum.current), {
            headers: {
              channel: 14,
              "session-token": allData.token,
            },
          })
          .then(function (response) {
            // validateurl returns a string ending in the server's remaining seconds.
            // Only override the local timer when we can parse a sane positive number —
            // a non-string / error body (e.g. an HTML/JSON error) would parse to NaN,
            // and a NaN date makes react-countdown fire "completed" immediately, which
            // wrongly shows the Session Expired modal.
            const d = typeof response?.data === "string" ? response.data.split(" ") : [];
            const remainingSecs = parseInt(d[d.length - 1], 10);
            if (Number.isFinite(remainingSecs) && remainingSecs > 0) {
              const serverDeadline = currentTime + remainingSecs * 1000;
              let persisted = NaN;
              try { persisted = parseInt(sessionStorage.getItem(timerKey), 10); } catch (e) { /* ignore */ }
              // Never EXTEND the countdown on (re)load: keep the EARLIEST known deadline so a
              // refresh can't push the timer back up — e.g. if validateurl returns a fresh full
              // duration on each call. The timer can only be shortened, never reset upward.
              const finalDeadline = Number.isFinite(persisted) ? Math.min(persisted, serverDeadline) : serverDeadline;
              setTimeLeft(finalDeadline);
              try { sessionStorage.setItem(timerKey, String(finalDeadline)); } catch (e) { /* ignore */ }
            }
            // else: keep the persisted/local countdown — don't expire.
          })
          .catch((e) => {
            // This is only a best-effort sync of the countdown to the server clock.
            // payment/data already validated the session (it returned 200, or we'd have
            // shown the modal in initializePayment). A validateurl failure — the sandbox
            // backend intermittently 403s this endpoint, and proxy/DNS hiccups also land
            // here — must NOT nuke the session. Degrade gracefully to the local 5-minute
            // countdown; the modal still fires if that timer genuinely runs out.
            analytics.track("session_timeout", {
              reason: "validateurl_failed",
              status: e?.response?.status,
            });
          });
      }
    }, 2000);
  };

  useEffect(() => {
    analytics.init(); // start the activity clock as early as possible
    initializePayment();
    // Hard 5-second master cap for the loading screen
    const maxLoader = setTimeout(() => {
      hideLoader();
    }, 5000);
    return () => clearTimeout(maxLoader);
  }, []);

  const initializePayment = async () => {
    try {
      let valObj = null;
      // Step 1: Fetch Payment Data (API 1)
      if (transactionId.current) {
        valObj = await getURLDatafromTransactionId(transactionId.current);
      } else if (refnum.current) {
        valObj = await getURLDatafromToken();
      } else {
        setData((prev) => ({ ...prev, show404: true }));
        hideLoader();
        return;
      }

      if (!valObj) {
        hideLoader();
        setShowModal(true);
        return;
      }

      // Step 2: Fetch Bank List (API 2) sequentially
      const searchData = getSearchData(valObj);
      if (searchData.token && searchData.divid) {
        localStorage.setItem("swinkpay_session_token", searchData.token);
        localStorage.setItem("swinkpay_devid", searchData.divid);
        localStorage.setItem("mid", searchData.mid);
        localStorage.setItem("color", searchData.color);
      } else {
        searchData.token = localStorage.getItem("swinkpay_session_token");
        searchData.divid = localStorage.getItem("swinkpay_devid");
        searchData.mid = localStorage.getItem("mid");
        searchData.color = localStorage.getItem("color");
      }

      // Update basic payment data immediately. Auto-fill the contact inputs from any pre-known
      // payer details the data API returned (Contact Details reads customerMobile/customerEmail).
      setData(prev => ({
        ...prev,
        ...searchData,
        customerMobile: searchData.userMobile || prev.customerMobile || "",
        customerEmail: searchData.userEmail || prev.customerEmail || "",
      }));

      // If the data API already provided a valid 10-digit mobile, the mandatory contact info is
      // known — skip the Contact Details screen and go straight to Payment Options. Email, name
      // and address stay optional. The values are auto-filled above and forwarded to the
      // firstleg / QR APIs under their original keys (userName/userMobile/userEmail/userAddress).
      if (/^[6-9]\d{9}$/.test(searchData.userMobile || "")) {
        setContactSubmitted(true);
      }
      // Attach transaction context to the activity session (no PII).
      analytics.init({
        txnId: searchData.transactionID,
        swinkpayId: searchData.swinkpayID,
        mid: searchData.mid,
        tid: searchData.tid,
        pg: searchData.pg,
        amount: searchData.totalAmount,
      });

      // TERMINAL load (success / failed): no payment-method selection or session
      // countdown happens on the result screen, so skip the bank-list fetch AND the
      // session-timeout (validateurl) polling — they were firing needlessly on every
      // load (and repeatedly, if the result screen reloads). The merchant logo is still
      // shown on the result screen, so fetch just that and finish.
      if ([1, 2].includes(searchData.statusCode)) {
        hideLoader();
        fetchLogoBackground(searchData);
        return;
      }

      // Start fetching bank list in background but we wait for it before hiding loader if within 5s
      const bankListPromise = axios.get(GetAPI("bank", searchData.pg), {
        headers: {
          channel: 14,
          auth_token: "FREFA45D$B2#18842765#992",
          "device-id": searchData.divid,
          "session-token": searchData.token,
        },
        timeout: 3000, // individual timeout to not block the whole 5s window
      });

      SessionTimeOut(searchData);

      try {
        const response = await bankListPromise;
        const all_banks = response.data?.data?.bankList || [];
        const filtered_banks = all_banks
          .filter((obj) => obj.pg.id === searchData.pg && obj.mop.id === 2)
          .map((obj) => ({ value: obj, label: obj.bankName }));
        const filtered_wallets = all_banks
          .filter((obj) => obj.pg.id === searchData.pg && obj.mop.id === 3)
          .map((obj) => ({ value: obj, label: obj.bankName }));
        
        setData(prev => ({ ...prev, bankList: filtered_banks, walletList: filtered_wallets }));
      } catch (e) {
        console.log("Bank list fetch background error", e);
      }

      // Step 3: UI Transition
      hideLoader();

      // Step 4: Fetch Logo (API 3) in background
      fetchLogoBackground(searchData);

    } catch (e) {
      console.log("Initialization error", e);
      hideLoader();
      setShowModal(true);
    }
  };

  const fetchLogoBackground = async (finalObj) => {
    try {
      const logoPath = finalObj.logo?.replace(/^https?:\/\/[^/]+/, "") || "";
      if (logoPath) {
        const imageRes = await axios.get(logoPath, {
          headers: {
            channel: 14,
            auth_token: "FREFA45D$B2#18842765#992",
            "device-id": finalObj.divid,
            "session-token": finalObj.token,
            "Content-Type": "multipart/form-data",
          },
          responseType: "arraybuffer",
          timeout: 5000,
        });
        if (imageRes?.data?.byteLength > 0) {
          const convertedURL = window.URL.createObjectURL(new Blob([imageRes.data]));
          setData(prev => ({ ...prev, merchant_logo: convertedURL }));
        }
      }
    } catch (e) {
      console.log("Logo fetch error", e);
    }
  };

  const getURLDatafromTransactionId = async (newId) => {
    try {
      const pHeaders = {
        channel: 14,
        auth_token: "FREFA45D$B2#18842765#992",
        "Content-Type": "application/json",
      };
      const newApiData = {
        refnum: newId,
      };

      let outputRes = await axios.post(
        GetAPI("apiForValidTransactionId"),
        newApiData,
        {
          headers: pHeaders,
          timeout: 8000,
        }
      );

      if (outputRes?.data?.error?.errorCode === -7004) {
        setData((prev) => ({ ...prev, show404: true }));
        return null;
      }
      return outputRes?.data?.status === 0 ? outputRes.data.data : null;
    } catch (e) {
      return null;
    }
  };

  const getURLDatafromToken = async () => {
    try {
      const pHeaders = {
        channel: 14,
        auth_token: "FREFA45D$B2#18842765#992",
        "Content-Type": "application/json",
      };
      const newApiData = {
        refnum: refnum.current,
      };

      let outputRes = await axios.post(GetAPI("apiForValidToken"), newApiData, {
        headers: pHeaders,
        timeout: 8000,
      });

      if (outputRes?.data?.error?.errorCode === -7004) {
        setData((prev) => ({ ...prev, show404: true }));
        return null;
      }
      return outputRes?.data?.status === 0 ? outputRes.data.data : null;
    } catch (e) {
      return null;
    }
  };

  const buttonStatus = () => {
    return (
      ["netBanking", "wallet", "UPI", "savedCard"].includes(formData?.type) ||
      formData?.isValidCard
    );
  };

  const checkNumberInBin = (givenNum) => {
    let listOfBins = data?.bins || [];
    return listOfBins.some((eachNum) => {
      if (givenNum.length > eachNum.length) {
        return givenNum.startsWith(eachNum);
      } else if (givenNum.length < eachNum.length) {
        return eachNum.startsWith(givenNum);
      } else {
        return eachNum == givenNum;
      }
    });
  };

  const handleProcessData = (e) => {
    e.preventDefault();
    if (formData?.modeOfPayment === "CARD" && data["bins"].length > 0) {
      // let result = formData.cardNumber.substring(0, 6);
      let result = checkNumberInBin(formData.cardNumber);
      if (!result) {
        setShowCardModal(true);
        return;
      }
    }
    handleSubmit();
  };

  const getErrorMessage = (p_type) => {
    if (p_type === "CARD") {
      return "Invalid card details";
    } else if (p_type === "UPI") {
      return "Invalid payment details";
    } else if (p_type === "NETBANKING") {
      return "Invalid payment details";
    } else {
      return "Invalid wallet details";
    }
  };

  const handleSubmit = async () => {
    if (processingRef.current) return; // double-click guard
    processingRef.current = true;
    analytics.track("payment_submit", {
      method: formData?.modeOfPayment,
      type: formData?.type,
    });
    analytics.flush("checkpoint_payment_submit"); // safety: the conversion moment

    setShowBackButton(false);
    setShowCardModal(false);
    // e.preventDefault();
    setData({ ...data, errorMessage: "" });
    SessionTimeOut(data);
    setInProcess(true);
    const firstlegdata = getFirstLegData(data, formData);
    let mainPG = ["UPI", "QRCODE"].includes(formData?.modeOfPayment)
      ? data.upiPG
      : data.cardPG;

    try {
      const tempHeaders = {
        channel: 14,
        auth_token: "FREFA45D$B2#18842765#992",
        "session-token": data?.token,
        "device-id": data?.divid,
        "Content-Type": "application/json",
      };
      let response = await axios.post(
        GetAPI("firstLeg", mainPG),
        firstlegdata,
        {
          headers: tempHeaders,
        }
      );
      if (response?.data?.error?.errorCode === -2201) {
        setShowBackButton(true);
        setInProcess(false);
        processingRef.current = false;
        if (allMethods.includes(formData?.modeOfPayment)) {
          let eMsg = getErrorMessage(formData?.modeOfPayment);
          setData({ ...data, errorMessage: eMsg });
        }
        return;
      }

      // Gateway accepted the firstLeg → the transaction is INITIATED. This marker
      // (and the swinkpayId) lets the merchant tell "initiated" sessions apart from
      // browse-only / abandoned ones. Attach the SP… id if the response carries it.
      const initiatedSwinkpayId = response?.data?.data?.transactionId || data?.swinkpayID || null;
      if (initiatedSwinkpayId) analytics.init({ swinkpayId: initiatedSwinkpayId });
      analytics.track("transaction_initiated", { method: formData?.modeOfPayment, pg: mainPG });
      analytics.flush("transaction_initiated");

      if (mainPG === 10) {
        isNavigatingRef.current = true;
        // Parse the PayU redirect HTML and submit the form from the current
        // document. This avoids both:
        //   - blob: URL navigation (blocked on iOS Safari ≥14 / Android WebView)
        //   - document.write (JS in written content is sandboxed in WKWebView
        //     in-app browsers, leaving a blank page)
        const html = atob(response.data.data.bdFirstLegResponse);
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const sourceForm = doc.querySelector("form");
        if (sourceForm) {
          const action = sourceForm.action;
          const inputsHtml = Array.from(sourceForm.querySelectorAll("input"))
            .map(inp => `<input type="hidden" name="${inp.name}" value="${inp.value.replace(/"/g, '&quot;')}">`)
            .join("");
          
          const formHtml = `
            <html>
              <body onload="document.forms[0].submit()">
                <form method="POST" action="${action}">
                  ${inputsHtml}
                </form>
              </body>
            </html>
          `;
          
          const blob = new Blob([formHtml], { type: 'text/html' });
          const blobUrl = URL.createObjectURL(blob);
          window.location.replace(blobUrl);
        }
      } else if ([8, 15].includes(mainPG)) {
        const url = response.data.data.bdFirstLegResponse;
        // window.open(url, "_self");
        if (formData?.modeOfPayment !== "UPI") {
          isNavigatingRef.current = true;
          window.location.replace(url);
        } else {
          setData(prev => ({ ...prev, statusCode: 0 }));
          setFormData({
            nextStep: "CHECKSTATUS",
          });
          setShowProcessingScreen(true);
        }
      } else if (mainPG === 2) {
        const bddata = JSON.parse(response.data.data.bdFirstLegResponse);
        const url = bddata.rdata.url;
        const inputParams = bddata.rdata.parameters;
        let queryParams = "";
        Object.entries(inputParams).forEach((param) => {
          queryParams += "&" + param[0] + "=" + param[1];
        });
        isNavigatingRef.current = true;
        window.location.replace(url + "?" + queryParams);
      } else if (mainPG === 12) {
        setData(prev => ({ ...prev, statusCode: 0 }));
        setFormData({
          nextStep: "CHECKSTATUS",
        });
        setShowProcessingScreen(true);
      }
      setInProcess(false);
      processingRef.current = false;
    } catch (e) {
      console.log("c", e);
      setInProcess(false);
      processingRef.current = false;
    }
  };

  const handleCheckStatus = async (e) => {
    if (terminalStateRef.current) return; // already success/failed — no more decision polls
    if (processingRef.current) return;
    processingRef.current = true;

    try {
      setShowBackButton(false);
      toast.dismiss();
      if (!data?.returnURL) {
        e?.preventDefault();
      }
      //SessionTimeOut();
      //setInProcess(true);

      const decisionData = {
        amount: FormatAmount(data["totalAmount"]),
        dateAndTime: dateFormat(Date(), "yyyy-mm-dd hh:MM:ss").toString(),
        invoiceNumber: data?.transactionID,
        terminalID: data["tid"], //data["tid"],
        txnID: data?.transactionID,
      };

      const decHeaders = {
        channel: 14,
        auth_token: "FREFA45D$B2#18842765#992",
        "session-token": data?.token,
        "device-id": data?.divid,
        "Content-Type": "application/json",
      };

      let response = await axios.post(GetAPI("decision"), decisionData, {
        headers: decHeaders,
      });

      // Support both transactionStatus (legacy) and statusCode (current API)
      const txnStatus = response?.data?.data?.transactionStatus ?? response?.data?.data?.statusCode;

      if (txnStatus === 0) {
        // Still pending — log only, do not change state
        if (!data?.returnURL) {
          toast(response.data.data.transactionStatusMsg ?? response.data.data.statusMessage ?? "Processing...");
        } else {
          console.log(response.data.data.transactionStatusMsg ?? response.data.data.statusMessage);
        }
      } else if (txnStatus === 1) {
        // Success — always land on the SwinkPay result screen; it captures the completion
        // and auto-redirects to the merchant returnURL after a short delay.
        const authData = await getURLDatafromTransactionId(response?.data?.data?.transactionId);
        terminalStateRef.current = true;
        setData({
          ...data,
          ...authData,
          swinkpayID: authData?.transactionId ?? response.data.data.transactionId,
          returnURL: response?.data?.data?.returnURL ?? data.returnURL,
          // Prefer authData's merReturnURL — it's the auth-API value that has the swinkpay
          // transactionId appended. The decision response carries no merReturnURL, so the old
          // `?? data.merReturnURL` fell back to the initial data-API URL (which was set before
          // transactionId existed), clobbering the correct value the `...authData` spread set.
          // This is the UPI-only txnId-drop bug: UPI completes via CHECKSTATUS (here), while
          // card/netbanking complete via handleAuthStatus, which has no such override.
          merReturnURL: authData?.merReturnURL ?? response?.data?.data?.merReturnURL ?? data.merReturnURL,
          statusCode: 1,
        });
      } else {
        // Failed — always land on the SwinkPay result screen (captures + auto-redirects).
        const authData = await getURLDatafromTransactionId(response?.data?.data?.transactionId);
        terminalStateRef.current = true;
        setData({
          ...data,
          ...authData,
          date: authData?.date ?? response?.data?.data?.date ?? data.date,
          swinkpayID: authData?.transactionId ?? response?.data?.data?.transactionId,
          returnURL: response?.data?.data?.returnURL ?? data.returnURL,
          // Same fix as the success branch: keep authData's merReturnURL (has transactionId)
          // instead of falling back to the stale initial data-API URL.
          merReturnURL: authData?.merReturnURL ?? response?.data?.data?.merReturnURL ?? data.merReturnURL,
          statusCode: 2,
        });
      }
      processingRef.current = false;
    } catch (Err) {
      console.log("Err...", Err);
      processingRef.current = false;
    }
  };

  const handleAuthStatus = async () => {
    if (terminalStateRef.current) return; // already success/failed — no more auth polls
    if (processingRef.current) return;
    processingRef.current = true;
    try {
      const authData = await getURLDatafromTransactionId(data?.swinkpayID || transactionId.current);
      if (authData) {
        const newStatus = parseInt(authData.statusCode);
        if ([1, 2].includes(newStatus)) {
          terminalStateRef.current = true;
        }
        setData(prev => ({ 
          ...prev, 
          ...authData, 
          statusCode: newStatus 
        }));
      }
      processingRef.current = false;
    } catch (e) {
      console.log("Auth poll error", e);
      processingRef.current = false;
    }
  };

  // Keep ref pointing at the latest handlers so the polling interval never stale-closes
  useEffect(() => { 
    handleCheckStatusRef.current = handleCheckStatus; 
    handleAuthStatusRef.current = handleAuthStatus;
  });

  useEffect(() => {
    // Stop polling once a terminal state (success=1 / failed=2) is reached. Without this
    // the poll runs forever: nextStep stays "CHECKSTATUS" after success, so the statusCode
    // 0→1 change re-runs this effect and sets up a fresh interval that keeps hitting
    // decision + auth on the success screen.
    if ([1, 2].includes(data?.statusCode) || terminalStateRef.current) return;
    if (formData?.nextStep !== "CHECKSTATUS" && data?.statusCode !== 0) return;
    let intervalCount = 0;
    const interval = setInterval(() => {
      if (deciload === 1) {
        if (formData?.nextStep === "CHECKSTATUS") {
          handleCheckStatusRef.current();
        } else if (data?.statusCode === 0) {
          handleAuthStatusRef.current();
        }
      }
      if (++intervalCount === 12) {
        window.clearInterval(interval);
        if (formData?.nextStep === "CHECKSTATUS") {
          setShowModal(true);
        }
      }
    }, 10000);
    return () => window.clearInterval(interval);
  }, [formData?.nextStep, data?.statusCode]);

  useEffect(() => {
    // Same terminal-state guard as the poll effect — don't restart the 120s pending timer
    // after a success/failed result has landed.
    if ([1, 2].includes(data?.statusCode) || terminalStateRef.current) return;
    if (formData?.nextStep !== "CHECKSTATUS" && data?.statusCode !== 0) return;
    setPendingSecondsLeft(120);
    setIsPendingTimerOver(false);
    const tick = setInterval(() => {
      setPendingSecondsLeft((prev) => {
        if (prev <= 1) {
          clearInterval(tick);
          setIsPendingTimerOver(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(tick);
  }, [formData?.nextStep, data?.statusCode]);

  const getSubmitButtonText = () => {
    switch (formData?.nextStep) {
      case "REQUESTMONEY":
        return "Request Money";
      case "CHECKSTATUS":
        if (data?.returnURL) {
          return "Checking Status";
        } else if (showModal) {
          return "Time Out";
        } else {
          return "Check Status";
        }
      default:
        return "Pay Now";
    }
  };

  const getEnabledFlag = () => {
    let commonFlag =
      data.card || data.netbanking || data.wallet || data.upiCollect;
    let newFlag = false;
    if (isIOS || isAndroid) {
      newFlag = commonFlag || data.upiDeepLink;
    } else {
      newFlag = commonFlag || data.upiDQR;
    }
    return newFlag;
  };

  const onCancelCard = () => setShowCardModal(false);

  const getPayNowBtnFlag = () =>
    !(
      buttonStatus() &&
      !(["CHECKSTATUS"].includes(formData?.nextStep) && data?.returnURL)
    );

  const isCheckingStatus =
    ["CHECKSTATUS"].includes(formData?.nextStep) && data?.returnURL && !showModal;

  const getSubmitBtnClsName = isCheckingStatus
    ? "text-white text-sm font-semibold h-10 rounded-lg flex-1 flex items-center justify-center gap-2 cursor-not-allowed shadow-md animate-pulse"
    : getPayNowBtnFlag()
    ? "text-white text-sm bg-gray-300 h-10 rounded-lg flex-1 flex items-center justify-center cursor-not-allowed"
    : "text-white text-sm font-semibold bg-gradient-to-r from-[#1E56C8] to-[#1340A0] h-10 rounded-lg flex-1 shadow-md transition-all duration-200 hover:shadow-lg hover:scale-[1.02] active:scale-[0.98] flex items-center justify-center gap-1";

  const getCancelBtnClsName =
    "text-[#DE554D] text-sm font-semibold border-2 border-[#DE554D] bg-white h-10 rounded-lg flex-1 transition-all duration-200 hover:bg-red-50 active:scale-[0.98] flex items-center justify-center";
  const showHeader = () => (
    <div
      className="flex-none w-full transition-all duration-300"
      style={{ height: (isKeyboardOpen && viewportWidth < 640) ? 60 : 112 }}
    >
      <Amount
        setShowModal={setShowModal}
        showModal={showModal}
        timeLeft={timeLeft}
        isKeyboardOpen={isKeyboardOpen}
        viewportWidth={viewportWidth}
      />
      {showModal && (
        <TimeOutModal showModal={showModal} setShowModal={setShowModal} />
      )}
      {showCardModal && (
        <CardInfoModal
          showModal={showCardModal}
          handleCancel={onCancelCard}
          handleSaveData={handleSubmit}
        />
      )}
    </div>
  );

  const handleTooltipToggle = () => {
    setShowTooltip(true);
  };

  const showDescription = () => (
    <div className="flex-none w-full">
      <div
        className="mx-3 my-1.5 px-3 py-2 rounded-xl flex items-center gap-2.5 cursor-pointer"
        style={{ background: "linear-gradient(90deg, rgba(30,86,200,0.08) 0%, rgba(30,86,200,0.04) 100%)",
                 border: "1px solid rgba(30,86,200,0.18)" }}
        onClick={() => setShowTooltip(true)}
      >
        <div className="w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0"
             style={{ background: "linear-gradient(135deg, #1E56C8, #1340A0)" }}>
          <MdOutlineShoppingBag className="text-white" style={{ fontSize: 15 }} />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-[10px] font-semibold text-[#1E56C8] uppercase tracking-wider mb-0.5">Order Summary</p>
          <p className="text-xs font-medium text-[#1340A0] truncate">{data.remarks}</p>
        </div>
        <span style={{ fontSize: 10, color: '#1E56C8', fontWeight: 600, flexShrink: 0, opacity: 0.7 }}>View ›</span>
      </div>
    </div>
  );

  const showRemarksModal = () => (
    <div
      style={{
        position: 'absolute', inset: 0, zIndex: 50,
        background: 'rgba(10,20,50,0.45)',
        backdropFilter: 'blur(3px)',
        display: 'flex', alignItems: 'flex-end',
      }}
      onClick={() => setShowTooltip(false)}
    >
      <div
        style={{
          width: '100%',
          background: '#fff',
          borderRadius: '20px 20px 0 0',
          paddingBottom: 28,
          boxShadow: '0 -8px 40px rgba(0,0,0,0.15)',
          animation: 'swink-sheet-up 0.32s cubic-bezier(0.22,1,0.36,1)',
        }}
        onClick={e => e.stopPropagation()}
      >
        {/* Handle bar */}
        <div style={{ display: 'flex', justifyContent: 'center', padding: '12px 0 6px' }}>
          <div style={{ width: 36, height: 4, borderRadius: 99, background: '#e2e8f0' }} />
        </div>

        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 20px 14px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            {/* Animated icon with sonar glow */}
            <div style={{ position: 'relative', width: 46, height: 46, flexShrink: 0 }}>
              {[0, 1].map(i => (
                <div key={i} style={{
                  position: 'absolute', inset: 0, borderRadius: 14,
                  border: '1.5px solid rgba(30,86,200,0.35)',
                  animation: `swink-sonar 2s ease-out ${i * 0.8}s infinite`,
                }} />
              ))}
              <div style={{
                position: 'absolute', inset: 4, borderRadius: 10,
                background: 'linear-gradient(135deg, #1E56C8, #1340A0)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                boxShadow: '0 4px 14px rgba(30,86,200,0.35)',
              }}>
                <MdOutlineShoppingBag style={{ color: '#fff', fontSize: 17 }} />
              </div>
            </div>
            <div>
              <p style={{ fontSize: 15, fontWeight: 700, color: '#0f172a', margin: 0 }}>Order Summary</p>
              <p style={{ fontSize: 11, color: '#94a3b8', margin: 0, marginTop: 2 }}>Purpose of this payment</p>
            </div>
          </div>
          <button
            onClick={() => setShowTooltip(false)}
            style={{
              width: 30, height: 30, borderRadius: '50%',
              background: '#f1f5f9', border: 'none', cursor: 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <AiOutlineClose style={{ fontSize: 13, color: '#64748b' }} />
          </button>
        </div>

        {/* Divider */}
        <div style={{ height: 1, background: '#f1f5f9', margin: '0 20px 16px' }} />

        {/* Remarks content */}
        <div style={{ padding: '0 20px' }}>
          <p style={{ fontSize: 13, color: '#374151', lineHeight: 1.8, margin: 0 }}>
            {data.remarks}
          </p>
        </div>
      </div>
    </div>
  );

  const showGrowPart = () => (
    <div
      className={`flex-grow min-h-0 w-full mt-1 mb-1 relative overflow-y-auto overflow-x-hidden ${
        inProcess ? "pointer-events-none" : ""
      } hide-scrollbar`}
    >
      {getEnabledFlag() ? (
        <div className="h-full">
          <PaymentOptions setIsNavigating={(val) => { isNavigatingRef.current = val; }} />
        </div>
      ) : (
        <div className="h-full flex flex-col items-center justify-center px-6 py-8 gap-4">
          {/* Icon */}
          <div className="w-16 h-16 rounded-2xl flex items-center justify-center"
               style={{ background: "rgba(30,86,200,0.08)", border: "1px solid rgba(30,86,200,0.15)" }}>
            <svg viewBox="0 0 24 24" className="w-8 h-8" fill="none" stroke="#1E56C8" strokeWidth="1.5">
              <rect x="2" y="5" width="20" height="14" rx="2" />
              <path d="M2 10h20" strokeWidth="1.5" />
              <path d="M6 15h4" strokeLinecap="round" />
              <circle cx="17" cy="15" r="1" fill="#1E56C8" stroke="none" />
            </svg>
          </div>

          {/* Title + description */}
          <div className="text-center">
            <h3 className="text-sm font-bold text-gray-800 mb-1">No Payment Methods Available</h3>
            <p className="text-xs text-gray-400 leading-relaxed" style={{ maxWidth: 230 }}>
              No payment options are enabled for this transaction. Please contact{" "}
              <span className="font-semibold text-gray-600">{data?.merchantName || "the merchant"}</span>{" "}
              to resolve this.
            </p>
          </div>

          {/* Guidance card */}
          <div className="w-full rounded-xl px-4 py-3 flex flex-col gap-2"
               style={{ background: "rgba(251,191,36,0.08)", border: "1px solid rgba(251,191,36,0.28)", maxWidth: 290 }}>
            <div className="flex items-center gap-2 mb-0.5">
              <svg viewBox="0 0 24 24" className="w-3.5 h-3.5 flex-shrink-0" fill="none">
                <path d="M12 9v4M12 17h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
                      stroke="#FBBF24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <p className="text-[11px] font-semibold text-amber-700">What you can do</p>
            </div>
            {["Try refreshing the page", "Contact the merchant for assistance", "Request a new payment link"].map((tip) => (
              <div key={tip} className="flex items-center gap-2">
                <div className="w-1 h-1 rounded-full flex-shrink-0" style={{ background: "#FBBF24" }} />
                <p className="text-[11px] text-gray-500">{tip}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );

  const showFooter = () => (
    <div className="flex-none w-full bg-white border-t border-gray-100">
      {/* Trust bar */}
      <div className="flex items-center justify-center gap-2 py-1.5 px-3">
        <FaLock className="text-[#1E56C8] text-xs" />
        <span className="text-[10px] text-gray-400 font-medium">256-bit Encrypted</span>
        <span className="text-gray-200 text-xs">|</span>
        <img src={pci} alt="pci_logo" className="h-5 w-auto" />
        <span className="text-gray-200 text-xs">|</span>
        <img src={swinkpay_logo} alt="swinkpay_logo" className="h-5 w-auto" />
      </div>
      {/* Button bar */}
      <div className="flex items-center justify-center p-2 gap-3">
        {data.backURL && showBackButton && (
          <button
            type="button"
            onClick={() => setShowCancelModal(true)}
            className={getCancelBtnClsName}
          >
            Cancel
          </button>
        )}
        <button
          type="submit"
          disabled={
            !buttonStatus() ||
            (["CHECKSTATUS"].includes(formData?.nextStep) && data?.returnURL) ||
            inProcess
          }
          className={getSubmitBtnClsName}
          style={isCheckingStatus ? { background: "linear-gradient(135deg, rgba(30,86,200,1), rgba(19,64,160,1))" } : {}}
        >
          <span>{getSubmitButtonText()}</span>
          {isCheckingStatus && (
            <svg
              className="animate-spin h-4 w-4 text-white flex-shrink-0"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle className="opacity-30" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
              <path className="opacity-90" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
            </svg>
          )}
        </button>
      </div>
    </div>
  );

  const showRenderedComponent = () => {
    let renderedComponent;
    if (isLoading || !dataReady) {
      return (
        <div style={{
          width: '100vw', height: '100vh',
          background: '#f5f8ff',
          display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center',
          position: 'relative', overflow: 'hidden',
        }}>
          {/* Subtle top blue accent bar */}
          <div style={{
            position: 'absolute', top: 0, left: 0, right: 0, height: 4,
            background: 'linear-gradient(90deg, #0f4a8a 0%, #1a6cb8 50%, #24CB7E 100%)',
          }} />

          {/* Large soft blue circle behind logo */}
          <div style={{
            position: 'absolute',
            width: '60vw', maxWidth: 320,
            aspectRatio: '1',
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(30,86,200,0.07) 0%, transparent 70%)',
            pointerEvents: 'none',
          }} />

          {/* SwinkPay logo — full color on light bg */}
          <img src={swinkpay_logo} alt="SwinkPay"
            style={{ height: 44, objectFit: 'contain', marginBottom: 40, animation: 'swink-fade-up 0.5s ease both' }} />

          <div className="mb-8">
            <SwinkSpinner size={92} />
          </div>

          {/* Status text */}
          <p style={{ color: '#1a2d5a', fontSize: 16, fontWeight: 700, margin: '0 0 6px', letterSpacing: 0.2 }}>
            Securing your payment
          </p>
          <p style={{ color: '#6b7fa8', fontSize: 12, margin: '0 0 28px' }}>
            Setting up a safe session for you
          </p>

          {/* Shimmer progress bar */}
          <div style={{
            width: 200, height: 4, borderRadius: 99,
            background: '#e2e8f5', overflow: 'hidden', marginBottom: 32,
          }}>
            <div style={{
              height: '100%', width: '45%', borderRadius: 99,
              background: 'linear-gradient(90deg, #1E56C8, #24CB7E)',
              animation: 'swink-progress 1.6s ease-in-out infinite',
            }} />
          </div>

          {/* Warning note — minimal, inline */}
          <div style={{
            display: 'flex', alignItems: 'flex-start', gap: 8,
            background: '#fffbeb',
            border: '1px solid #fde68a',
            borderRadius: 12, padding: '10px 18px',
            maxWidth: 280, textAlign: 'left',
          }}>
            <span style={{ fontSize: 14, marginTop: 1 }}>⚠️</span>
            <span style={{ fontSize: 11.5, color: '#92400e', lineHeight: 1.6 }}>
              <strong>Do not press Back or Refresh</strong><br />
              Your payment may fail if you navigate away
            </span>
          </div>

          {/* Trust bar */}
          <div style={{
            position: 'absolute', bottom: 24,
            display: 'flex', alignItems: 'center', gap: 10,
          }}>
            <FaLock style={{ color: '#94a3b8', fontSize: 10 }} />
            <span style={{ color: '#94a3b8', fontSize: 10 }}>256-bit Encrypted</span>
            <div style={{ width: 1, height: 12, background: '#cbd5e1' }} />
            <img src={pci} alt="PCI DSS" style={{ height: 18, opacity: 0.5 }} />
          </div>
        </div>
      );
    }
    if ([1, 2].includes(data?.statusCode) || (data?.statusCode === 0 && isPendingTimerOver)) {
      renderedComponent = <SuccessOrFailed setIsNavigating={(val) => { isNavigatingRef.current = val; }} />;
    } else if (data?.statusCode === 0) {      // Pending / Transaction Processing
      renderedComponent = (
        <div className="payment-page-bg" style={{ width: '100vw', height: '100vh', position: 'relative', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div
            style={viewportWidth >= 640 ? {
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: Math.max(400, viewportWidth * 0.38),
              height: Math.min(780, Math.max(480, viewportHeight - 24)),
              borderRadius: 16,
              overflow: 'hidden',
              zIndex: 10,
            } : {
              position: 'fixed',
              top: 0, left: 0, right: 0, bottom: 0,
              zIndex: 10,
            }}
            className="flex flex-col bg-gray-50 card-glow"
          >
            {/* Amber top accent bar */}
            <div style={{ flexShrink: 0, height: 4, background: 'linear-gradient(90deg, #F59E0B 0%, #FBBF24 50%, #FDE68A 100%)' }} />

            {/* Scrollable content area */}
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '24px 20px' }}>
              <div className="mb-8">
                <SwinkSpinner size={92} />
              </div>

              <p style={{ color: '#1a2d5a', fontSize: 20, fontWeight: 800, margin: '0 0 8px', textAlign: 'center' }}>
                Payment Pending
              </p>
              <p style={{ color: '#6b7fa8', fontSize: 13, margin: '0 0 8px', textAlign: 'center', maxWidth: 260, lineHeight: 1.6 }}>
                Your transaction is being processed. Please do not close this window.
              </p>
              <p style={{ color: '#94a3b8', fontSize: 11, margin: '0 0 16px', textAlign: 'center' }}>
                {data?.statusMessage || 'Transaction Processing'}
              </p>
              {/* Live countdown */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 28 }}>
                <AiFillClockCircle style={{ color: '#F59E0B', fontSize: 14 }} />
                <span style={{ fontSize: 13, color: '#92400e', fontWeight: 600 }}>
                  Checking for {Math.floor(pendingSecondsLeft / 60)}:{String(pendingSecondsLeft % 60).padStart(2, '0')} more
                </span>
              </div>
              <div style={{
                background: '#fffbeb', border: '1px solid #fde68a',
                borderRadius: 12, padding: '10px 20px',
                display: 'flex', alignItems: 'flex-start', gap: 8, maxWidth: 280,
              }}>
                <span style={{ fontSize: 14 }}>⚠️</span>
                <span style={{ fontSize: 11.5, color: '#92400e', lineHeight: 1.6 }}>
                  <strong>Do not press Back or Refresh</strong><br />
                  Your payment may fail if you navigate away
                </span>
              </div>
            </div>

            {/* Trust footer — pinned to bottom */}
            <div style={{ flexShrink: 0, padding: '12px 0', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, borderTop: '1px solid #f1f5f9' }}>
              <FaLock style={{ color: '#94a3b8', fontSize: 10 }} />
              <span style={{ color: '#94a3b8', fontSize: 10 }}>256-bit Encrypted</span>
              <div style={{ width: 1, height: 12, background: '#cbd5e1' }} />
              <img src={pci} alt="PCI DSS" style={{ height: 18, opacity: 0.5 }} />
              <div style={{ width: 1, height: 12, background: '#cbd5e1' }} />
              <img src={swinkpay_logo} alt="SwinkPay" style={{ height: 18, opacity: 0.55 }} />
            </div>
          </div>
        </div>
      );
    } else if (data.show404) {
      renderedComponent = <Page404 />;
    } else {
      renderedComponent = (
        <>
          <div className="payment-page-bg" style={{ width: '100vw', height: '100vh', position: 'relative', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

            {/* ── Animated orbs ── */}
            <div className="hidden sm:block absolute pointer-events-none"
                 style={{ top: "-220px", left: "-220px", width: 600, height: 600, borderRadius: "50%",
                   background: "radial-gradient(circle, rgba(30,86,200,0.28) 0%, transparent 70%)",
                   filter: "blur(80px)" }} />
            <div className="hidden sm:block absolute pointer-events-none"
                 style={{ bottom: "-200px", right: "-200px", width: 560, height: 560, borderRadius: "50%",
                   background: "radial-gradient(circle, rgba(222,85,77,0.22) 0%, transparent 70%)",
                   filter: "blur(70px)" }} />
            <div className="hidden sm:block absolute pointer-events-none"
                 style={{ top: "40%", left: "42%", width: 380, height: 380, borderRadius: "50%",
                   background: "radial-gradient(circle, rgba(99,102,241,0.14) 0%, transparent 70%)",
                   filter: "blur(60px)" }} />

            {/* ── Payment icon pattern overlay ── */}
            <svg className="hidden sm:block absolute inset-0 w-full h-full z-0 pointer-events-none" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <pattern id="pay-tile-a" x="0" y="0" width="120" height="80" patternUnits="userSpaceOnUse">
                  {/* Credit card outline */}
                  <rect x="8" y="16" width="52" height="34" rx="5" ry="5"
                    fill="none" stroke="rgba(30,86,200,0.07)" strokeWidth="1.5" />
                  <line x1="8" y1="26" x2="60" y2="26" stroke="rgba(30,86,200,0.07)" strokeWidth="1.5" />
                  {/* Lock */}
                  <rect x="76" y="32" width="14" height="11" rx="2" ry="2"
                    fill="none" stroke="rgba(30,86,200,0.07)" strokeWidth="1.5" />
                  <path d="M79 32 v-4 a4 4 0 0 1 8 0 v4"
                    fill="none" stroke="rgba(30,86,200,0.07)" strokeWidth="1.5" />
                  {/* Shield */}
                  <path d="M98 18 l10 4 v8 c0 5-10 10-10 10 s-10-5-10-10 v-8 z"
                    fill="none" stroke="rgba(30,86,200,0.07)" strokeWidth="1.5" />
                </pattern>
                <pattern id="pay-tile-b" x="60" y="40" width="120" height="80" patternUnits="userSpaceOnUse">
                  <rect x="8" y="16" width="52" height="34" rx="5" ry="5"
                    fill="none" stroke="rgba(30,86,200,0.07)" strokeWidth="1.5" />
                  <line x1="8" y1="26" x2="60" y2="26" stroke="rgba(30,86,200,0.07)" strokeWidth="1.5" />
                  <rect x="76" y="32" width="14" height="11" rx="2" ry="2"
                    fill="none" stroke="rgba(30,86,200,0.07)" strokeWidth="1.5" />
                  <path d="M79 32 v-4 a4 4 0 0 1 8 0 v4"
                    fill="none" stroke="rgba(30,86,200,0.07)" strokeWidth="1.5" />
                  <path d="M98 18 l10 4 v8 c0 5-10 10-10 10 s-10-5-10-10 v-8 z"
                    fill="none" stroke="rgba(30,86,200,0.07)" strokeWidth="1.5" />
                </pattern>
              </defs>
              <rect width="100%" height="100%" fill="url(#pay-tile-a)" />
              <rect width="100%" height="100%" fill="url(#pay-tile-b)" />
            </svg>

            {/* ── Payment card with glow ── */}
            <div className="hidden sm:block absolute inset-0 pointer-events-none z-0" />
          <form
            onSubmit={
              formData?.nextStep === "CHECKSTATUS"
                ? handleCheckStatus
                : handleProcessData
            }
            style={viewportWidth >= 640 ? {
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: Math.max(400, viewportWidth * 0.38),
              height: Math.min(780, Math.max(480, viewportHeight - 24)),
              borderRadius: 16,
              overflow: 'hidden',
              zIndex: 10,
            } : {
              position: 'fixed',
              top: 0, left: 0, right: 0, bottom: 0,
              zIndex: 10,
            }}
            className="flex flex-col bg-gray-50 card-glow"
          >
            {showProcessingScreen ? (
              <ProgessScreen
                setShowModal={setShowModal}
                setShowProcessingScreen={setShowProcessingScreen}
                showModal={showModal}
                timeLeft={timeLeft}
              />
            ) : !contactSubmitted ? (
              <>
                {showHeader()}
                <ContactDetails
                  data={data}
                  showCancel={data.backURL && showBackButton}
                  onCancel={() => setShowCancelModal(true)}
                  onContinue={(mobile, email) => {
                    setData((prev) => ({ ...prev, customerMobile: mobile, customerEmail: email }));
                    setContactSubmitted(true);
                  }}
                />
              </>
            ) : (
              <>
                {showHeader()}
                {data.remarks && (!isKeyboardOpen || viewportWidth >= 640) && showDescription()}
                {showGrowPart()}
                {showFooter()}
                {showTooltip && showRemarksModal()}
                {inProcess && (
                  <div className="absolute inset-0 bg-slate-200 bg-opacity-50 z-10 flex items-center justify-center">
                    <Spinner size="50" />
                  </div>
                )}
              </>
            )}
          </form>
          </div>

          <Toaster
            position="bottom-center"
            reverseOrder={false}
            containerStyle={{
              bottom: 100,
            }}
          />
        </>
      );
    }
    return renderedComponent;
  };

  return (
    <>
      {showRenderedComponent()}
      {showCancelModal && (() => {
        const terminalGuard = terminalStateRef.current;
        // On the completed status screen, "Leave" only makes sense if there's a REAL (non-self)
        // merchant URL to go to; otherwise we just keep the user on the receipt.
        let leaveURL = null;
        if (terminalGuard) {
          const mr = data.merReturnURL || data.returnURL;
          let selfRef = false;
          try { selfRef = !!mr && new URL(mr, window.location.href).pathname.includes("/plugin"); } catch (e) { /* keep */ }
          leaveURL = mr && !selfRef ? mr : null;
        }
        return (
          <CancelButtonModal
            title="Transaction Guard"
            message={terminalGuard
              ? (<>Your payment is <span className="font-bold text-[#1E56C8]">complete and secured</span>. Do you want to leave this page?</>)
              : undefined}
            primaryLabel={terminalGuard ? "Stay on this Page" : undefined}
            secondaryLabel={terminalGuard ? "Leave Anyway" : undefined}
            onGoBack={() => {
              setShowCancelModal(false);
              if (terminalGuard) {
                // Payment already complete — leaving is optional, not "abandoning".
                if (leaveURL) {
                  isNavigatingRef.current = true;
                  window.location.replace(leaveURL);
                }
                // else: nowhere real to go → stay on the receipt.
                return;
              }
              // Active payment flow: this is a genuine abandon.
              isNavigatingRef.current = true;
              analytics.track("payment_abandoned", { terminal: false });
              analytics.flush("payment_abandoned");
              if (data.backURL) {
                window.location.replace(data.backURL);
              } else {
                setData((prev) => ({ ...prev, show404: true }));
              }
            }}
            onCloseCancelButtonModal={() => {
              analytics.track("cancel_dismissed");
              setShowCancelModal(false);
            }}
          />
        );
      })()}
    </>
  );
};

export default PaymentMode;
